// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__1Abzd","label":"input_label__1D4sS","err":"input_err__22aAs","boder_err":"input_boder_err__lrQaG"};